// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"25be29c1616e5c5b8f7a","223":"edc60a7b340991f65dc2","293":"d72992fbaf6f7cc7acb9"}[chunkId] + ".js";
};